import { FC, useEffect, useMemo, useState } from "react";
import { DashboardDevice } from "../../../../../../models/api/DashboardDevice";
import { CurrentWidgetMeasurementConfig } from "../../../SimpleAppTemplate";
import useCurrentAirQualityPMIndicator from "../hooks/useCurrentAirQualityPMIndicator";
import { getIndicator } from "../../WidgetHelper";

type Props = {
  device: DashboardDevice;
  orgId?: string;
  measurement: CurrentWidgetMeasurementConfig;
};

// TODO: Informative Comment
const CurrentAirQualityPMIndicator: FC<Props> = ({ device, orgId, measurement }) => {
  const [valueLabel, setValueLabel] = useState<string>("Particulate Matter");
  const { fetchData, data, isLoading } = useCurrentAirQualityPMIndicator(device.id);

  useEffect(() => {
    if (measurement) {
      // Required
      const name = measurement.name;
      const fieldKey = measurement.fieldKey;

      // Optional
      const displayName = measurement.displayName;
      const fieldName = measurement.fieldName;
      const portNumber = parseInt(measurement.port ?? "0");
      const label = measurement.label;
      if (label) setValueLabel(label);

      const hasError = !name || !fieldKey;
      if (!hasError) {
        const getData = async () => {
          await fetchData({
            name,
            fieldKey,
            displayName,
            fieldName,
            portNumber,
            orgId,
          });
        };

        getData();
      }
    }
  }, [measurement, orgId]);

  const GetCurrentAirQualityPMIndicator = useMemo(() => {
    return getIndicator(data, valueLabel, isLoading);
  }, [data, valueLabel, isLoading]);

  return <>{GetCurrentAirQualityPMIndicator}</>;
};

export default CurrentAirQualityPMIndicator;
